import { Splide } from '@splidejs/react-splide'

const options = {
  direction: 'rtl',
  perMove: 1,
  autoplay: true,
  loop: true,
  interval: 3500,
  arrows: false,
  pagination: false,
  rewind: true,
  pauseOnFocus: true,
  pauseOnHover: true,
  gap: 16,
  focus: 'center',
  breakpoints: {
    640: {
      perPage: 1,
    },
    768: {
      perPage: 2,
    },
    1024: {
      perPage: 3,
    },
    1280: {
      perPage: 4,
    },
  },
  perPage: 5,
}

export default function SilderSponsersLogos({ title, type, children }) {
  return (
    <div className="app-container px-8 lg:px-0">
      <div
        data-aos="fade-up"
        className="flex flex-col justify-evenly"
      >
        <h1 className={`mb-4 ${type === 'DIAMOND' ? 'bg-info' : 'bg-warning'} py-2 text-center text-[18px] font-bold text-white`}>{title} </h1>
        <Splide
          aria-label={`Sponsors Logos Slider`}
          options={options}
        >
          {children}
        </Splide>
      </div>
    </div>
  )
}
